module.exports = __webpack_public_path__ + "img/index4.796bd4ef.png";